import { Routes } from '@angular/router';
import { PageNotFoundComponent } from './page-not-found.component';
import { DashboardComponent } from './dashboard.component';
import { TestPanelComponent } from './testing-tools/test-panel.component';
import { JobRedirectComponent } from './job-redirect.component';
import { canDeactivateGuard } from '@aifs-shared/auth/guard.fn';

export const routes: Routes = [
  { path: '', component: DashboardComponent },
  { path: 'home', component: DashboardComponent },
  { path: 'cauto', component: TestPanelComponent },
  { path: 'assigned', loadChildren: () => import('./staff-work/routes') },
  { path: 'job/:jobId', component: JobRedirectComponent },
  {
    path: 'job/:jobId/details',
    loadChildren: () => import('./applicant/routes'),
  },
  {
    path: 'job/:jobId/review',
    loadChildren: () => import('./applicant/application/review/routes'),
  },
  {
    path: 'job/:jobId/medical',
    loadChildren: () => import('./applicant/application/medical/routes'),
  },{
    path: 'job/:jobId/chase-up',
    loadChildren: () => import('./applicant/application/chase-up/routes'),
  },
  {
    path: 'job/:jobId/criminal',
    loadChildren: () => import('./applicant/application/criminal/routes'),
  },
  { path: 'maintain', loadChildren: () => import('./maintain/routes') },
  { path: 'work-area', loadChildren: () => import('./work-area/routes') },
  { path: 'interviewer', loadChildren: () => import('./interviewer/routes') },
  { path: 'applicant', loadChildren: () => import('./applicant/routes') },
  {
    path: 'red-flag-investigation/:applicationId',
    loadComponent: () =>
      import('./applicant/red-flag-investigation/red-flag-investigation.component').then(
        (m) => m.RedFlagInvestigationComponent
      ),
    canDeactivate: [canDeactivateGuard],
  },
  { path: '**', component: PageNotFoundComponent },
];
